var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 28,
    viewBox: "0 0 38 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.486,
    height: 26.4859,
    rx: 13.243,
    transform: "matrix(-1 0 0 1 27.4004 0.925781)",
    fill: "#F16347"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0885 14.1687C37.0885 6.85486 31.1594 0.925781 23.8455 0.925781C23.338 0.925781 22.8372 0.954327 22.3446 1.0099C21.2103 0.992749 20.0725 1.26305 19.0498 1.8208C19.0221 1.83158 18.9944 1.84245 18.9667 1.85341C18.9725 1.85544 18.9827 1.85416 18.996 1.85044C18.4687 2.14443 17.9727 2.51546 17.5246 2.96355L12.1322 8.35588C9.52626 10.9618 9.52624 15.1869 12.1322 17.7928C13.845 19.5057 16.2574 20.0927 18.4497 19.5539C19.6102 19.2776 20.711 18.6868 21.6164 17.7814L26.8167 12.581C26.9464 12.4514 27.0687 12.3204 27.1841 12.1882C27.281 12.8343 27.3312 13.4957 27.3312 14.1689C27.3312 19.7598 23.8665 24.5416 18.967 26.4842C20.4767 27.0827 22.1227 27.4117 23.8455 27.4117C31.1594 27.4117 37.0885 21.4826 37.0885 14.1687Z",
    fill: "#F0DC29"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f7170c68822a1a01b734fc7c49628674.svg";
export { ForwardRef as ReactComponent };